module.exports = __webpack_public_path__ + "b770c3d49a87d98964e13bccf3b60d6b.jpg";